import gql from 'graphql-tag'

export const SIGN_OUT_MUTATION = gql`
  mutation SignOutMutation {
    signOut
  }
`



// WEBPACK FOOTER //
// ./src/mutations/SIGN_OUT_MUTATION.ts